export type HttpStatusCode = 400 | 401 | 403 | 404 | 500;

export const HttpStatusCode: Record<`C${HttpStatusCode}`, HttpStatusCode> = {
  C400: 400,
  C401: 401,
  C403: 403,
  C404: 404,
  C500: 500,
};
